//refer to read me for structure ref
const apiList = {
  login: {
    guest: `/login/guest`,
    refresh: `/login/refresh`,
  },
  captive: {
    getOtp: `/login/captive/otp`,
    local: `/login/captive/local`,
  },
  homepage: {
    getProducts: `/pax2/v2/api/products/landingPage`,
    landingPageConstruct: `/pax2/v2/api/products/landingPageConstruct`,
    displayCollection: `/pax2/v2/api/products/displayCollection`,
  },
  stores: {
    getStores: `/pax2/v2/api/shops/getStores`,
  },
  products: {
    productDetail: `/pax2/v2/api/products/item`,
    productCategory: `/pax2/v2/api/products/category`,
    productId: `/pax2/v2/api/products/productId`,
  },
  cart: {
    summary: `/pax2/v2/api/cart/summary`,
    checkout: `/pax2/v2/api/cart/checkout`,
    myCart: `/pax2/v2/api/cart/mycart`,
    saveCart: `/pax2/v2/api/cart/save`,
  },
  paymentSuccess: {
    orderSummary: `/pax2/v2/api/order/summary`,
  },
  paymentProcess: {
    paymentStatus: `/pax2/v2/api/order/paymentStatus/{{orderId}}`,
  },
  gate: {
    gateListing: `/fis/v2/api/aodb/gates`,
  },
  user: {
    info: `/gw/api/user/info`,
    getapplicablepromo: `/promotions/v1/api/promotion/getapplicablepromo`,
  },
  termsOfUse: "/cms/api/pages/terms-of-use",
  privacyPolicy: "/cms/api/pages/privacy-policy",
};

export default apiList;
